module.exports = __webpack_public_path__ + "assets/img/mo-guest-page-layer-9-82eb1b17.png";